import "core-js/modules/es.array.reverse.js";
var _dec, _dec2, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import ModelTraits from "../ModelTraits";
import primitiveTrait from "../Decorators/primitiveTrait";
let GetCapabilitiesTraits = (_dec = primitiveTrait({
  type: "string",
  name: "GetCapabilities URL",
  description: "The URL at which to access to the OGC GetCapabilities service."
}), _dec2 = primitiveTrait({
  type: "string",
  name: "GetCapabilities Cache Duration",
  description: "The amount of time to cache GetCapabilities responses."
}), _class = class GetCapabilitiesTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "getCapabilitiesCacheDuration", _descriptor, this);
  }
  get getCapabilitiesUrl() {
    return;
  }
}, _applyDecoratedDescriptor(_class.prototype, "getCapabilitiesUrl", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "getCapabilitiesUrl"), _class.prototype), _descriptor = _applyDecoratedDescriptor(_class.prototype, "getCapabilitiesCacheDuration", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "1d";
  }
}), _class);
export { GetCapabilitiesTraits as default };